
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import { config } from '@/config';
import type { Database } from './types';

const SUPABASE_URL = config.SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = config.SUPABASE_ANON_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";
if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error("SUPABASE_URL or SUPABASE_PUBLISHABLE_KEY is not set");
}

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
